export default {"src":"/_next/static/media/hugeicons_maps-location.e9379097.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};